import React, { Component } from 'react';
import { MsalContext } from "@azure/msal-react";

// Styles
import './Dashboard.scss';

//Import components
import DashboardMenu from './templates/DashboardMenu';
import DashboardHeader from './templates/DashboardHeader';

import { loginRequest } from "../../authConfig";
import { callMsGraph } from "../../graph";

export default class Dashboard extends Component{

  static contextType = MsalContext;

  state = {
    userName: "",
    userPrincipalName: "",
    userAvatar: "",
    lastModify: "",
    graphData: null,
    userPhoto: null,
    menuView: null,
    headerTitle: "",
    country: '',
    countryCode: ''
  }
  
  componentDidMount() {
    this.requestProfileData();
    this.setState({
      countryCode: this.props?.countriesCode,
      country: this.props?.country,
    });
    window.sessionStorage.setItem("maz_abi_digitalsalesportal_front_copec_user_country", this.props?.country);
    window.sessionStorage.setItem("maz_abi_digitalsalesportal_front_copec_user_country_code", this.props?.countriesCode);
  }

  setHeaderTitle = (title) => {
    this.setState({
      headerTitle: title
    });
  }

  setGraphData = (data) => {
    this.setState({
      graphData: data
    });
  }

  setUserPhoto = (data) => {
    this.setState({
      userPhoto: data
    });
  }

  setMenuView = (view) => {
    this.setState({
      menuView: view
    });
  }

  requestProfileData() {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    this.context.instance.acquireTokenSilent({
      ...loginRequest,
      account: this.context.accounts[0]
    }).then((response) => {
      callMsGraph(response.accessToken).then(response => {
        this.setGraphData(response);
        this.setState({
          userName: response.displayName.toUpperCase(),
          userPrincipalName: response.userPrincipalName
        })
      });

    }).catch((e) => {
      console.log(e);
    });
  }
  
  selectedCountry(countryS){
    this.props.selectedCountry(countryS)
  }

  render() {
    const userData = {
      userName: this.state.userName,
      lastModify: this.state.lastModify,
      userPrincipalName: this.state.userPrincipalName
    };
    if (this.state.countryCode) {
    return (
      <div className="dashboard">
        <DashboardHeader 
          headerTitle={this.state.headerTitle}
          userData={userData} 
          dataUser={this.props?.userData}
          countries={this.props?.country}
          countriesCode={this.state.countryCode}
          selectedCountry={e => this.selectedCountry(e)}
        />

        <DashboardMenu 
          userData={this.props.userData}
          setViewContent={this.setMenuView}
          setHeaderTitle={this.setHeaderTitle} 
          countriesCode={this.state.countryCode}
        />

        <div className="dashboard__content">

          {this.state.menuView}

        </div>

      </div>
      );
    }
      return (<> </>);
    
  }
}